import React from "react";
import ProductsList2 from "./productsList2";

export default function ProductsList() {
  return (
    <div>
    <div className="min-h-screen bg-gray-100 p-4 md:p-8">
      <div className="bg-white shadow rounded-lg overflow-hidden">
        {/* Header */}
        <div className="flex flex-wrap items-center justify-between gap-3 p-4 border-b">
          <h1 className="text-2xl font-semibold text-gray-800">Products</h1>
          <div className="flex flex-wrap gap-2">
            <button className="bg-blue-600 text-white px-4 py-2 rounded hover:bg-blue-700 text-sm">
              + Add new
            </button>
            <button className="bg-sky-500 text-white px-4 py-2 rounded hover:bg-sky-600 text-sm">
              ✏️ Bulk edit products
            </button>
            <button className="bg-purple-500 text-white px-4 py-2 rounded hover:bg-purple-600 text-sm">
              📄 Download catalog as PDF
            </button>
            <button className="bg-green-600 text-white px-4 py-2 rounded hover:bg-green-700 text-sm">
              ⬇️ Export
            </button>
            <button className="bg-emerald-500 text-white px-4 py-2 rounded hover:bg-emerald-600 text-sm">
              ⬆️ Import
            </button>
            <button className="bg-red-600 text-white px-4 py-2 rounded hover:bg-red-700 text-sm">
              🗑️ Delete (selected)
            </button>
          </div>
        </div>

        {/* Search Section */}
        <div className="p-6">
          <h2 className="text-lg font-medium text-gray-700 mb-4 flex items-center gap-2">
            🔍 Search
          </h2>

          {/* Form Grid */}
          <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 2xl:grid-cols-4 gap-6">
            {/* Left Column */}
            <div>
              <label className="block text-gray-600 text-sm font-medium mb-1">
                Product name
              </label>
              <input
                type="text"
                className="w-full border rounded p-2 focus:ring focus:ring-blue-300 outline-none"
                placeholder="Enter product name"
              />
            </div>

            <div>
              <label className="block text-gray-600 text-sm font-medium mb-1">
                Category
              </label>
              <select className="w-full border rounded p-2 focus:ring focus:ring-blue-300 outline-none">
                <option>All</option>
              </select>
            </div>

            <div className="flex items-center gap-2">
              <input type="checkbox" id="subcategories" className="w-4 h-4" />
              <label
                htmlFor="subcategories"
                className="text-gray-700 text-sm font-medium"
              >
                Search subcategories
              </label>
            </div>

            <div>
              <label className="block text-gray-600 text-sm font-medium mb-1">
                Manufacturer
              </label>
              <select className="w-full border rounded p-2 focus:ring focus:ring-blue-300 outline-none">
                <option>All</option>
              </select>
            </div>

            <div>
              <label className="block text-gray-600 text-sm font-medium mb-1">
                Vendor
              </label>
              <select className="w-full border rounded p-2 focus:ring focus:ring-blue-300 outline-none">
                <option>All</option>
              </select>
            </div>

            {/* Right Column */}
            <div>
              <label className="block text-gray-600 text-sm font-medium mb-1">
                Warehouse
              </label>
              <select className="w-full border rounded p-2 focus:ring focus:ring-blue-300 outline-none">
                <option>All</option>
              </select>
            </div>

            <div>
              <label className="block text-gray-600 text-sm font-medium mb-1">
                Product type
              </label>
              <select className="w-full border rounded p-2 focus:ring focus:ring-blue-300 outline-none">
                <option>All</option>
              </select>
            </div>

            <div>
              <label className="block text-gray-600 text-sm font-medium mb-1">
                Published
              </label>
              <select className="w-full border rounded p-2 focus:ring focus:ring-blue-300 outline-none">
                <option>All</option>
              </select>
            </div>

            <div>
              <label className="block text-gray-600 text-sm font-medium mb-1">
                Go directly to product SKU
              </label>
              <div className="flex gap-2">
                <input
                  type="text"
                  className="w-full border rounded p-2 focus:ring focus:ring-blue-300 outline-none"
                  placeholder="Enter SKU"
                />
                <button className="bg-sky-600 text-white px-4 py-2 rounded hover:bg-sky-700">
                  Go
                </button>
              </div>
            </div>
          </div>

          {/* Search Button */}
          <div className="mt-8 flex justify-center">
            <button className="bg-sky-600 text-white px-6 py-3 rounded flex items-center gap-2 hover:bg-sky-700">
              🔍 Search
            </button>
          </div>
        </div>
      </div>
       <ProductsList2 />
    </div>
   
    </div>
  );
}
